import { render, staticRenderFns } from "./ComplaintTelForm.vue?vue&type=template&id=4cb84014&scoped=true&"
import script from "./ComplaintTelForm.vue?vue&type=script&lang=js&"
export * from "./ComplaintTelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb84014",
  null
  
)

export default component.exports